import { Chart, registerables } from 'chart.js';
import Annotation from 'chartjs-plugin-annotation';
import "chartjs-adapter-date-fns"; //requires date-fns < 4 so don't upgrade that package
Chart.register(...registerables, Annotation);
